<div class="outer-cointainer">
<h3 class="header">{{isEdit == true ? 'Change' : 'Add'}} URL</h3>
  <div class="container">
    <form [formGroup]="urlInput">
      <mat-form-field appearance="standard">
        <mat-label>Your Url</mat-label>
        <input matInput autocomplete="off" required formControlName="uploadURLInput" multiple>
        <mat-error *ngIf="urlInput.controls.uploadURLInput.hasError('required')">
          Url required
        </mat-error>
        <mat-error *ngIf="urlInput.controls.uploadURLInput.hasError('pattern')">
          Url Pattern Invalid
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  <ng-container *ngIf="referenceType === 'SALEPROFILE' || !referenceType">
    <div class="toggle-container">
      <div class="left-toggle-container">
        <mat-icon>share</mat-icon>
        <span class="sharing-text">Enable sharing for this URL</span>
      </div>
      <mat-slide-toggle [(ngModel)]="isSharing" labelPosition="before" color="primary"></mat-slide-toggle>
    </div>
  </ng-container>
  <div class="d-flex flex-row justify-content-end">
    <div>
      <button mat-button color="warn" (click)="closeURLDialogRef()"> Cancel</button>
      <button mat-button color="primary" (click)="isEdit == false ? addURLInput() : ChangeURL()" [nbSpinner]="isUploadURL"
        [disabled]="!urlInput.valid || isUploadURL">Save</button>
    </div>
  </div>
</div>